export default __webpack_public_path__ + "static/media/img12.d1fc8b59.png";